import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import Client from "../../entity/b2c/Client";

const SERVICE = "service-b2c";
const ENTITY = "clients";

export default function () {
    const {findOneBy} = useApi();
    const state = useSelector;
    const newInstance = data => new Client(data);

    return {
        findOneById(id) {
            return {
                select() {
                    const result = state(state => state.api?.b2c?.[ENTITY]?.[id]);

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    findOneBy(SERVICE, ENTITY, "id", id, newInstance, "application_v7");
                }
            }
        }
    }
}